// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579694328687
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/views/ConfirmCompanies/ConfirmCompanies.scss
// module id = ./src/views/ConfirmCompanies/ConfirmCompanies.scss
// module chunks = 0